module.exports = __webpack_public_path__ + "img/healthcasts.dfe5452a.png";